import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './styles/tokens.css';
import './styles/base.css';
import './styles/components.css';

import { App } from './App.jsx';
import { UIProvider } from './components/ui/feedback.jsx';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <UIProvider>
      <App />
    </UIProvider>
  </StrictMode>,
);

/*
  Service worker poskrbi, da se aplikacija odpre tudi brez povezave in da
  so zadnji znani podatki vidni. Podrobnosti so v public/sw.js.

  V razvoju ga ne registriramo — predpomnjen app shell bi zakrival
  spremembe, ki jih Vite servira na živo.
*/
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});

    // Nova verzija appa je prevzela nadzor — osveži, da ne mešamo
    // stare kode z novo.
    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (refreshing) return;
      refreshing = true;
      window.location.reload();
    });
  });
}
